import {
  adminRoles,
  agencyAdminRoles,
  agencyRoles,
  agentRoles,
  brandRoles,
  masterAdminRoles,
  providerDirectorRoles,
  providerRoles,
} from '@functions/role'

export function isAdmin(roleTitle: string) {
  return adminRoles.includes(roleTitle)
}

export function isMasterAdmin(roleTitle: string) {
  return masterAdminRoles.includes(roleTitle)
}

export function isAgencyAdmin(roleTitle: string) {
  return agencyAdminRoles.includes(roleTitle)
}

export function isAgent(roleTitle: string) {
  return agentRoles.includes(roleTitle)
}

export function isAgencyUser(roleTitle: string) {
  return agencyRoles.includes(roleTitle)
}

export function isProviderDirector(roleTitle: string) {
  return providerDirectorRoles.includes(roleTitle)
}

export function isProviderUser(roleTitle: string) {
  return providerRoles.includes(roleTitle)
}

export function isBrandUser(roleTitle: string) {
  return brandRoles.includes(roleTitle)
}
